import { NgModule } from '@angular/core';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyPrimeNGModule } from '@ngx-formly/primeng';
import { FormlyDatepickerModule } from '@ngx-formly/primeng/datepicker';
import { DynamicFormComponent } from './dynamic-form/dynamic-form.component';
import { CustomTemplateTypeComponent } from './types/custom-template/custom-template-type.component';
import { FormlyDatepickerTypeComponent } from './types/datepicker/datepicker-type.component';
import { FormlyDividerTypeComponent } from './types/divider/divider-type.component';
import { FormlyEditorTypeComponent } from './types/editor/editor-type.component';
import { FormlyGalleryTypeComponent } from './types/gallery/gallery-type.component';
import { FormlyMultiSelectLazyTypeComponent } from './types/multiselect-lazy/multiselect-lazy-type.component';
import { FormlyMultiselectTypeComponent } from './types/multiselect/multiselect-type.component';
import { FormlyPasswordTypeComponent } from './types/password/password-type.component';
import { FormlyPhoneNumberTypeComponent } from './types/phone-number/phone-number-type.component';
import { FormlyRepeatTableTypeComponent } from './types/repeat-table/repeat-table-type.component';
import { FormlyRepeatTypeComponent } from './types/repeat/repeat-type.component';
import { FormlySelectLazyTypeComponent } from './types/select-lazy/select-lazy-type.component';
import { FormlySelectTypeComponent } from './types/select/select-type.component';
import { FormlyTabsRepeatTypeComponent } from './types/tabs-repeat/tabs-repeat-type.component';
import { FormlyTabsTypeComponent } from './types/tabs/tabs-type.component';
import { FormlyFieldButtonWrapperComponent } from './wrappers/button/filed-button-wrapper.component';
import { FormlyCollapseWrapperComponent } from './wrappers/collapse/collapse-wrapper.component';
import { FormlyFieldIconWrapperComponent } from './wrappers/field-icon/field-icon-wrapper.component';
import { FormlyFormFieldWrapperComponent } from './wrappers/form-field/form-field-wrapper.component';

@NgModule({
  imports: [
    FormlyPrimeNGModule,
    FormlyDatepickerModule,
    FormlyModule.forRoot({
      wrappers: [
        {
          name: 'form-field',
          component: FormlyFormFieldWrapperComponent,
        },
        {
          name: 'collapse',
          component: FormlyCollapseWrapperComponent,
        },
        {
          name: 'field-icon',
          component: FormlyFieldIconWrapperComponent,
        },
        {
          name: 'field-button',
          component: FormlyFieldButtonWrapperComponent,
        },
      ],
      types: [
        {
          name: 'tabs',
          component: FormlyTabsTypeComponent,
        },
        {
          name: 'tabs-repeat',
          component: FormlyTabsRepeatTypeComponent,
        },
        {
          name: 'input',
          wrappers: ['form-field'],
        },
        {
          name: 'divider',
          component: FormlyDividerTypeComponent,
        },
        {
          name: 'multiselect',
          component: FormlyMultiselectTypeComponent,
          wrappers: ['form-field'],
        },
        {
          name: 'multiselect-lazy',
          component: FormlyMultiSelectLazyTypeComponent,
          wrappers: ['form-field'],
        },
        {
          name: 'select',
          component: FormlySelectTypeComponent,
          wrappers: ['form-field'],
        },
        {
          name: 'select-lazy',
          component: FormlySelectLazyTypeComponent,
          wrappers: ['form-field'],
        },
        {
          name: 'repeat',
          component: FormlyRepeatTypeComponent,
        },
        {
          name: 'repeat-table',
          component: FormlyRepeatTableTypeComponent,
        },
        {
          name: 'editor',
          component: FormlyEditorTypeComponent,
        },
        {
          name: 'phone-number',
          component: FormlyPhoneNumberTypeComponent,
          wrappers: ['form-field'],
        },
        {
          name: 'password',
          component: FormlyPasswordTypeComponent,
          wrappers: ['form-field'],
        },
        {
          name: 'gallery',
          component: FormlyGalleryTypeComponent,
          wrappers: ['form-field'],
        },
        {
          name: 'datepicker',
          component: FormlyDatepickerTypeComponent,
          wrappers: ['form-field'],
        },
        {
          name: 'custom-template',
          component: CustomTemplateTypeComponent,
          wrappers: ['form-field'],
        },
      ],
    }),
    DynamicFormComponent,
  ],
  exports: [],
})
export class DynamicFormModule {}
